import { LinkModel } from "@projectstorm/react-diagrams";
import { BaseEvent } from "@projectstorm/react-canvas-core";
import { useDispatch } from "react-redux";
import { setToast } from "../app/appSlice";
import { useGraph } from "./useGraph";
import { NodeKind } from "../pages/editor/diagram/nodes/DataNodeModel";
import { useLazyGetCatalogQuery } from "../pages/libraries/DataLibrarySlice";
import { useEffect } from "react";
import { useAppSelector } from "./hooks";
import { ITopology } from "../app/apiSlice";

const useLinkChecker = () => {
  const { engine, render } = useGraph();
  const dispatch = useDispatch();
  const [getCatalog, { data: catalog }] = useLazyGetCatalogQuery();
  const topologyRedux = useAppSelector((state) => state.editor.current);

  useEffect(() => {
    if (topologyRedux && !catalog)
      getCatalog({ runtimeType: topologyRedux.runtimeMode }, true);
  }, [topologyRedux]);

  //   Link can't began from "entrée" for function node or  "enregistrement" for sink nodes port.
  // So, when user's try to do these actions, a pop-up is launched to warn user's about the bad action
  const unauthorizedLink = (link: LinkModel, topologyRedux: ITopology|undefined) => {
    if(topologyRedux){
      // @ts-ignore
      if (link.sourcePort.options.alignment === "left") {
        // @ts-ignore
        link.sourcePort.removeLink(link);
        // @ts-ignore
        // remove link who doesn't respect rules
        if (engine) engine.getModel().removeLink(link);
        dispatch(
          setToast({
            title: "Lien impossible",
            content: `Impossible de tirer un lien depuis un port d'entrée !`,
            severity: "error",
            life: 5000,
          })
        );
      }
      if (topologyRedux.runtimeMode == "basic" && topologyRedux.modeBatch == true && Object.values(link.getSourcePort().getLinks()).length > 0) {
        // if (engine) engine.getModel().removeLink(link);
        // dispatch(
        //   setToast({
        //     title: "Lien impossible",
        //     content: `En mode basique avec l'option Batch, une seule sortie par boite`,
        //     severity: "error",
        //     life: 5000,
        //   })
        // );
      }
    }
  };

  //sink sourcePort can't receive more than one link
  //function sourcePort can't receive more than one link
  const maxOneLinkByPort = (event: BaseEvent, link: LinkModel) => {
    if (
      // @ts-ignore
      Object.keys(event.port.links).length > 1 &&
      // @ts-ignore
      event.port.parent.kind === NodeKind.SINK
    ) {
      // @ts-ignore
      link.sourcePort.removeLink(link);
      // @ts-ignore
      link.targetPort.removeLink(link);
      // remove link who doesn't respect rules
      if (engine) engine.getModel().removeLink(link);
      let type = "";
      // @ts-ignore
      if (event.port.parent.kind === NodeKind.FUNCTION) type = "fonction";
      else type = "cible";

      dispatch(
        setToast({
          title: "Lien vers brique cible",
          content: `Une brique de type ${type} peut accueillir au maximum un lien`,
          severity: "error",
          life: 5000,
        })
      );
    }
  };

  const unauthorizedLoop = (link: LinkModel) => {
    /* @ts-ignore */
    const sourceid = link?.getSourcePort().getParent().getOptions().id;
    /* @ts-ignore */
    const targetid = link?.getTargetPort().getParent().getOptions().id;
    if (catalog && sourceid && targetid) {
      const dagArray = render({
        hidePassword: false,
        catalog: catalog,
      });
      const sourceContainTargetId = dagArray?.find((item) => item.id === sourceid)?.out?.includes(targetid);
      const targetContainSourceId = dagArray?.find((item) => item.id === targetid)?.out?.includes(sourceid);
      if (
        sourceContainTargetId &&
        targetContainSourceId
      ) {
        // @ts-ignore
        link.sourcePort.removeLink(link);
        // @ts-ignore
        link.targetPort.removeLink(link);
        // remove link who doesn't respect rules
        if (engine) engine.getModel().removeLink(link);

        dispatch(
          setToast({
            title: "Port erreur",
            content: `Les boucles ne sont pas autorisées !`,
            severity: "error",
            life: 5000,
          })
        );
      }
    }
  };

  return {
    unauthorizedLink,
    unauthorizedLoop,
    maxOneLinkByPort,
  };
};

export default useLinkChecker;
